export enum ExperienceNoteType {
  Info = 1,
  Serviceable = 2,
  Unserviceable = 3,
  Shop = 4,
}
export default ExperienceNoteType;
